import { gEnums } from 'global/enums/globalEnums'
import GenericCard from 'global/genericControls/GenericCard'
import GenericList from 'global/genericControls/GenericList'
import GenericProfile from 'global/genericControls/GenericProfile'
import ManifestPreview from 'global/manifest/ManifestPreview'
import GolfTeams from 'projectSpecific/golf/elements/GolfTeams'
import { Segment } from 'semantic-ui-react'
import Splash from '../alerts/Splash'
import SignIn from '../auth/SignIn'

export const FormPreview = ({ formItemType, previewType, localData, itemProp, subKey }) => {

  switch (previewType) {
    case gEnums.previewTypes.display:
      return <div>DISPLAY</div>
    case gEnums.previewTypes.manifest:
      return <ManifestPreview formData={localData} />
    case gEnums.previewTypes.splashScreen:
      return <Splash formData={localData} />
    case gEnums.previewTypes.signIn:
      return <SignIn />
    case gEnums.previewTypes.golferTeamSelect:
      return <GolfTeams forSelect={true} />
    case gEnums.previewTypes.dataFilters:
      return <Segment inverted>dataFilters</Segment>
    case gEnums.previewTypes.list:
      return <GenericList formData={localData} itemProp={itemProp} subKey={subKey} />
    case gEnums.previewTypes.card:
    case gEnums.previewTypes.header:
    case gEnums.previewTypes.sectionBody:
    case gEnums.previewTypes.sectionHeader:
    case gEnums.previewTypes.profile:
      switch (subKey) {
        case 'description':
        case 'header':
        case 'meta':
          return <GenericProfile formData={localData} itemProp={itemProp} subKey={subKey} />
        default:
          return <GenericCard formData={localData} itemProp={itemProp} />
      }
    default:
      return <div>{'No available form item settings for ' + formItemType}</div>
  }
}
